import React from 'react';

export const ContentWrapper = ({children}) => <div style={{paddingLeft: 24, paddingRight: 24}}>{children}</div>;

export default ContentWrapper;